import React from 'react';
import { Card, Descriptions } from 'antd';
import { CalculatorOutlined } from '@ant-design/icons';
import PermissionGuard from '../../components/PermissionGuard';
import { Modules } from '../../constants/permissions';
import { usePW9531Execute } from './hooks/usePW9531Execute';
import ExecuteParamsPanel from './components/ExecuteParams';
import ResultTable from './components/ResultTable';
import './PW9531Form.css';

const PW9531Form: React.FC = () => {
  const {
    year, setYear,
    month, setMonth,
    attendStartYear, setAttendStartYear,
    attendStartMonth, setAttendStartMonth,
    attendEndYear, setAttendEndYear,
    attendEndMonth, setAttendEndMonth,
    loading,
    result,
    status,
    errors,
    execute,
    preview,
  } = usePW9531Execute();

  return (
    <PermissionGuard module={Modules.PW9531} action="query">
      <div className="pw9531-container">
        <div className="pw9531-header">
          <h2><CalculatorOutlined style={{ marginRight: 8 }} />薪資計算</h2>
        </div>

        {/* Last run status */}
        {status && status.lastRunAt && (
          <div className="pw9531-status-card">
            <Descriptions size="small" column={4}>
              <Descriptions.Item label="上次執行年度">{status.lastYear}</Descriptions.Item>
              <Descriptions.Item label="上次執行月份">{status.lastMonth}</Descriptions.Item>
              <Descriptions.Item label="處理人數">{status.lastProcessed}</Descriptions.Item>
              <Descriptions.Item label="執行時間">
                {new Date(status.lastRunAt).toLocaleString('zh-TW')}
              </Descriptions.Item>
            </Descriptions>
          </div>
        )}

        {/* Execute parameters */}
        <Card title="執行參數" size="small" style={{ marginBottom: 16 }}>
          <ExecuteParamsPanel
            year={year}
            month={month}
            attendStartYear={attendStartYear}
            attendStartMonth={attendStartMonth}
            attendEndYear={attendEndYear}
            attendEndMonth={attendEndMonth}
            loading={loading}
            errors={errors}
            onYearChange={setYear}
            onMonthChange={setMonth}
            onAttendStartYearChange={setAttendStartYear}
            onAttendStartMonthChange={setAttendStartMonth}
            onAttendEndYearChange={setAttendEndYear}
            onAttendEndMonthChange={setAttendEndMonth}
            onExecute={execute}
            onPreview={preview}
          />
        </Card>

        {/* Results */}
        <Card title="計算結果" size="small">
          <ResultTable
            results={result?.results ?? null}
            processed={result?.processed ?? 0}
            loading={loading}
          />
        </Card>
      </div>
    </PermissionGuard>
  );
};

export default PW9531Form;
